"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { CircleDollarSign, Loader2, Trash2 } from "lucide-react";
import CurrencyFormatter from "../utils/currencyFormatter";

const CheckFundsBeforeDelete = ({
  open,
  setOpen,
  onDelete,
  onFunds,
  assetBalances,
  subAccountName,
  mainAccount,
  loading,
  account,
  port,
}) => {
  const formatter = new CurrencyFormatter();
  const transfers = [];
  console.log("assetBalances", assetBalances);
  const cryptoAssets = assetBalances?.crypto || {};
  const fiatAssets = assetBalances?.fiat || {};
  const hasCrypto = Object.values(cryptoAssets).some(
    (asset) => asset?.availableAmount > 0
  );
  const hasFiat = Object.values(fiatAssets).some(
    (asset) => asset?.availableAmount > 0
  );
  const hasAssets = hasFiat || hasCrypto;

  const collectTransfers = (assetGroup) => {
    Object.entries(assetGroup).forEach(([symbol, asset]) => {
      const amount = parseFloat(asset.availableAmount);

      if (amount && amount > 0) {
        transfers.push({
          userId: account?.userId,
          accountIdFrom: account?._id,
          accountIdTo: mainAccount?._id,
          amount: amount,
          assetId: asset.assetId,
        });
      }
    });
  };
  console.log("transfers", transfers);
  if (hasFiat) collectTransfers(assetBalances.fiat);
  if (hasCrypto) collectTransfers(assetBalances.crypto);

  const handleTransferAndDelete = () => {
    onDelete?.(transfers, account);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md p-6 rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-[24px] text-[#FF4D4D] font-semibold mt-5 mb-3">
            {!hasAssets ? "Delete Account" : "Transfer & Delete Account"}
          </DialogTitle>
        </DialogHeader>

        <div className="mb-4">
          <p className="text-[14px] text-[#6D6584]">
            You need to transfer all the assets from this sub account back to
            your main account before deletion.
          </p>
        </div>

        {hasAssets && (
          <div className="mb-4 space-y-3">
            {hasFiat &&
              Object.entries(assetBalances.fiat).map(([symbol, asset], i) => (
                <div
                  key={`fiat-${i}`}
                  className="text-sm bg-gray-100 p-2 rounded"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={asset?.assetIcon}
                      alt={asset?.assetName}
                      width={32}
                      height={32}
                      className="text-white"
                    />
                    {asset.assetName}:{" "}
                    {formatter.format(
                      asset?.availableAmount,
                      asset?.asset?.toUpperCase()
                    )}
                  </div>
                </div>
              ))}
            {hasCrypto &&
              Object.entries(assetBalances.crypto).map(([symbol, asset], i) => (
                <div
                  key={`crypto-${i}`}
                  className="text-sm bg-gray-100 p-2 rounded"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={asset?.assetIcon}
                      alt={asset?.assetName}
                      width={32}
                      height={32}
                      className="text-white"
                    />
                    {asset.assetName}:{" "}
                    {formatter.format(
                      asset?.availableAmount,
                      asset?.asset?.toUpperCase()
                    )}
                  </div>
                </div>
              ))}
          </div>
        )}
        {!hasAssets && (
          <div className="text-sm text-green-600 mb-4">
            No assets found — ready to delete.
          </div>
        )}
        {/* Action Buttons */}
        <div className="grid grid-cols-2 mt-6">
          <div className="pr-2">
            <DialogClose className="w-full">
              <Button className="text-[#6D6584] font-semibold text-[14px] rounded-full bg-transparent border border-gray-300 hover:opacity-90 w-full py-5">
                Cancel
              </Button>
            </DialogClose>
          </div>
          <div className="pl-2">
            <Button
              className="text-sm font-semibold text-white rounded-full bg-gradient-to-tr from-red-500 to-purple-500 hover:opacity-90 w-full py-5"
              onClick={handleTransferAndDelete}
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin w-4 h-4" />
                  <span className="ml-2">Processing...</span>
                </>
              ) : !hasAssets ? (
                "Confirm"
              ) : (
                "Transfer & Delete"
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CheckFundsBeforeDelete;
